import * as FwDatas from "../FwDatas.ts";
import * as i18n from "../i18n.ts";
import * as modal from "../util/modal.ts";
import * as amplify from "../util/amplify.ts";
import * as DateUtils from "../lib/DateUtils.ts";
import {askCalendarUrl} from "../calendar/calendar_modal.js";

export{openCreateTimetable,openPickCreateTimetable,openEditTimetable}

function openEditTimetable(timetable){
  import("./timetable_edit.mustache").then(function(TPL_TIMETABLE){
    var theModal = modal.openModal(TPL_TIMETABLE,timetable);
    if(timetable.isOneTime){
      initFormOneTime(theModal,true)
    }else{
      initForm(theModal,true)
    }
  });
}
async function openPickCreateTimetable(){
  
  import("./modal_timetable_picktype.mustache").then(function(TPL_MODAL){
    modal.openModal(TPL_MODAL,{})
  })
  /* use new picker but some weird stuff with emoji
  var button = await modal.pick({
    title:"timetable.typetitle",
    gap:"var(--space-s)",
    button:[
      {title:"timetable.repeating_title",text:"timetable.repeating_description",emoji:'🔁',onclick:()=>Html.triggerbystring(null,'timetablecreate')},
      {title:"timetable.non_repeating_title",text:"timetable.non_repeating_description",emoji:'1️⃣',onclick:()=>Html.triggerbystring(null,'timetablecreate|oneTime')},
      {title:"timetable.import_title",text:"timetable.import_description",emoji:'🔗',onclick:()=>Html.triggerbystring(null,'timetablecreate|withUrl')},
    ]})
  if(button){
    button.onclick()
  }
  */
}
async function openCreateTimetable(type){
  var 
    withUrl = type === "withUrl",
    isOneTime = withUrl || type === "oneTime",
    icalSubscriptionUrl;
  
  if(withUrl){
    icalSubscriptionUrl = await askCalendarUrl({title:'timetable.icssubscription'});
    if(!icalSubscriptionUrl) return
    var isGood = await new Promise((resolve,reject)=>{
      ApiServer.evtcalcheckurl(icalSubscriptionUrl,resolve,reject)
    })
    if(!isGood){
      modal.oops("calendars.calbyurl.errortext");
      return;
    }
    
  } 
  const TPL_TIMETABLE = await import("./timetable_edit.mustache")
  
  let 
    userSettings = FwDatas.getSettingsPerFamily()||{},
    calendarFirstDayOfWeek = userSettings.calendarFirstDayOfWeek || DateUtils.getFirstDayOfWeek(),
    startDateLocale = DateUtils.getStartOfDay(new Date()),
    startDate = new Date(startDateLocale.toISOString().substring(0,19)+'Z');
  
  if(calendarFirstDayOfWeek===0) calendarFirstDayOfWeek = 7;
  var deltaFirstDayOfWeekDay = calendarFirstDayOfWeek - startDate.getDay();  
  if(deltaFirstDayOfWeekDay>0){
    startDate = DateUtils.dateAdd(startDate,{day:deltaFirstDayOfWeekDay-7})
  }else{
    startDate = DateUtils.dateAdd(startDate,{day:deltaFirstDayOfWeekDay})
  }
  var finishDate = DateUtils.dateAdd(startDate,{week:52});
  var theModal = modal.openModal(TPL_TIMETABLE,{
    recurrencyDescriptor:{recurrencyInterval:1},
    //*emoji:'😀',
    startDate:startDate,
    finishDate:finishDate,
    calendarFirstDayOfWeek,
    isOneTime,
    icalSubscriptionUrl,
    rights:{canShare:true}
  })
  if(isOneTime){
    initFormOneTime(theModal,false)
  }else{
    initForm(theModal,false)
  }
  
  
    
}


function initForm(obj,isEdit){
  var 
    form = obj.find("form").get(0),
    startDateInput = $(form.startDate),
    firstDayOfWeekInput = $(form.calendarFirstDayOfWeek),
    currentWeekSelect = obj.find("[name='currentWeek']"),
    
    recurrencyIntervalInput = obj.find("[name='recurrencyInterval']"),
    originalRecurrencyInterval = recurrencyIntervalInput.val(),
    firstOccurrenceOffset = obj.find("[name='firstOccurrenceOffset']"),
    originalFirstOccurrenceOffset = parseInt(firstOccurrenceOffset.val());
  
  if(firstDayOfWeekInput.get(0).nodeName==='SELECT'){
    firstDayOfWeekInput.html(DateUtils.getWeekDays().map((dayData)=>`<option value=${dayData.index}>${dayData.name}</option>`).join(''));
  }
  
  function setFirstDayOfWeekValue(){
    var value = startDateInput.dateValue();
    firstDayOfWeekInput.val(value.getDay()===0?7:value.getDay())
  }
  setFirstDayOfWeekValue();
  startDateInput.on('change',setFirstDayOfWeekValue);
  
  firstDayOfWeekInput.on('change',function(){
    var originalDate = startDateInput.dateValue();
    originalDate.setDate(originalDate.getDate() - originalDate.getDay() + parseInt(firstDayOfWeekInput.val())%7);
    startDateInput.dateValue(originalDate)
  });
  
  function initFirstOccurrenceOffset(){
    let 
      weekCount = parseInt(recurrencyIntervalInput.val())||1,
      text = i18n.get(weekCount>4?'timetable.weeknumberN':('timetable.weeknumber'+weekCount),weekCount),
      firstOccurrenceOffsetValue = parseInt(firstOccurrenceOffset.val())||parseInt(firstOccurrenceOffset.data('value')) ||0;
    while(firstOccurrenceOffsetValue>(weekCount-1)){
      firstOccurrenceOffsetValue--;
    }
    recurrencyIntervalInput.next('p').text(text);
    if(weekCount===1){
      firstOccurrenceOffset.parent().hide()
      firstOccurrenceOffset.html(`<option value="0" selected></option>`)
      
    }else{
      firstOccurrenceOffset.parent().show();
      let options = [];
      for(var i =0;i<weekCount;i++){
        options.push(i18n.get('timetable.week')+' '+String.fromCharCode(65+i))
      }
      firstOccurrenceOffset.html(options.map((o,idx)=>`<option value="${idx}" ${idx===firstOccurrenceOffsetValue?'selected':''}>${o}</option>`).join(''))
      
      let currentWeek = (getCurrentWeekIndex() + firstOccurrenceOffsetValue + weekCount)%weekCount;
      currentWeekSelect.html(options.map((o,idx)=>`<option value="${idx}" ${idx===currentWeek?'selected':''}>${o}</option>`).join(''))
      
    }
  }
  recurrencyIntervalInput.on('change',initFirstOccurrenceOffset);
  initFirstOccurrenceOffset();

  function setFirstOccurrenceOffsetFromCurrentWeek(){
    let 
      weekCount = parseInt(recurrencyIntervalInput.val());
    firstOccurrenceOffset.val((currentWeekSelect.val()-getCurrentWeekIndex()+ weekCount)%weekCount)
  }
  currentWeekSelect.on('change',setFirstOccurrenceOffsetFromCurrentWeek)
  if(currentWeekSelect.length){
    startDateInput.on('change',setFirstOccurrenceOffsetFromCurrentWeek);
      
  }
  
  function getCurrentWeekIndex(){
    var 
      weekCount = recurrencyIntervalInput.val(),
      startDate = startDateInput.dateValue(),
      firstWeekEndDate = DateUtils.dateAdd(startDate,{day:7}),
      endDate = DateUtils.dateAdd(startDate,{week:weekCount}),
      currentWeekSeeker = new Date(),
      deltaWeekCount = 0;
    
    //firt of all we position our crawler in the range
    while(currentWeekSeeker<startDate){
      currentWeekSeeker = DateUtils.dateAdd(currentWeekSeeker,{week:weekCount});
    }
    while(currentWeekSeeker>endDate){
      currentWeekSeeker = DateUtils.dateAdd(currentWeekSeeker,{week:-weekCount});
    }
    //then we seek in which week it is
    while(currentWeekSeeker>firstWeekEndDate){
      deltaWeekCount++;
      currentWeekSeeker = DateUtils.dateAdd(currentWeekSeeker,{week:-1});
    }
    return deltaWeekCount;
    
  }
  ApiServer['custom.evttimetableput'] = function(form){
    function doit(){
      ApiServer.evttimetableput.prepare({allowDeleteEvent:true})(obj,afterPutBuilder(obj,isEdit))  
    }
    if(isEdit && originalRecurrencyInterval>recurrencyIntervalInput.val()){
      var 
        weeks = ['A','B','C','D','E','F','G','H','I','J','K','L','M'].slice(0,originalRecurrencyInterval),
        text;
      //reorder weeks according to originalFirstOccurrenceOffset
      weeks.splice(0,0,...weeks.splice(originalFirstOccurrenceOffset,150))
      //remove after new count
      weeks.splice(0,recurrencyIntervalInput.val())
      
      if(weeks.length>1){
        text = i18n.get('timetable.educationnalreduceweeks',{a:weeks.slice(0,weeks.length-1).join(', '),b:weeks[weeks.length-1]});
      }else{
        text = i18n.get('timetable.educationnalreduceweek',{a:weeks[weeks.length-1]});
      }
        
      modal.ask({
        title:'new_confirm_action.title',
        message:text,
        lottie:"images/lottie/face_with_monocle.json",
        button:[
          {title:'actions.yesdelete',class:'negative',onclick:doit},
          {title:'actions.cancel',class:"secondary",onclick:function(){
            recurrencyIntervalInput.val(originalRecurrencyInterval)
          }},
          ]
      })
    }else{
      doit()
    }
    
  }
} 

function initFormOneTime(formModal,isEdit){
  var 
    form = formModal.find("form").get(0),
    firstDayOfWeekInput = $(form.calendarFirstDayOfWeek);
  
  if(firstDayOfWeekInput.get(0).nodeName==='SELECT'){
    firstDayOfWeekInput.html( DateUtils.getWeekDays().map((day)=>`<option value=${day.index}>${day.name}</option>`).join(''));
  }
  firstDayOfWeekInput.val(firstDayOfWeekInput.attr('data-value'))
  ApiServer['custom.evttimetableput'] = ApiServer.evttimetableput.prepare({allowDeleteEvent:true},afterPutBuilder(formModal,isEdit))
} 

function afterPutBuilder(formModal,isEdit){
  return function(freshTimetable){
    modal.closeModal(formModal)
    if(!isEdit){
      modal.simple({
        title:"timetable.createdtitle",
        message:"timetable.createdmessage",
        lottie:"images/lottie/anim_verified_check.json",
        button:"actions.start"
      },undefined,()=>{amplify.publish('timetableUpdated',freshTimetable)})
    }else{
      amplify.publish('timetableUpdated',freshTimetable)
    }
  }
}
